// TIDAK TERPAKAI — komponen pendukung V1: hanya dipakai oleh halaman V1 (frontend/src/pages/) dan/atau AppShell.jsx (V1), yang keduanya tidak terjangkau sejak App.js mengarahkan semua rute ke V2App. Jangan diedit. Lihat memory/DEPRECATED.md.
// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE
// version  : 1.0
// updated  : 2026-06-15
// replaces : -
// protected: NO  -> Tambahkan riwayat di /app/memory CHANGELOG saat diubah.
// =============================================================================

import React from "react";

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-5">
    <div>
      <h1 className="text-xl sm:text-2xl font-semibold font-display tracking-tight">{title}</h1>
      {subtitle && <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>}
    </div>
    {children && <div className="flex items-center gap-2">{children}</div>}
  </div>
);
